import { ProjectActionTypes } from "./constants";

export const setProjects = (projects) => ({
  type: ProjectActionTypes.SET_PROJECTS,
  payload: projects,
});

export const setProjectsError = (error) => ({
  type: ProjectActionTypes.SET_PROJECTS_ERROR,
  payload: error,
});

export const setSelectedProject = (project) => ({
  type: ProjectActionTypes.SET_SELECTED_PROJECT,
  payload: project,
}); 